import {SellerError} from './SellerError.js'

export class ConfirmAppointmentGenericSellerError extends SellerError {}
